import { useTranslation } from 'react-i18next';

import { mixpanelTrackEvent } from '@/lib/mixpanel';
import { APP_DOWNLOAD_FROM_SMART_PRICING_URL } from '@/utils/appOffers/alliances';
import { buildOfferRows } from './offerRows';
import { SaleIcon } from './SaleIcon';
import { APP_OFFERS_CALLOUT_SOURCE } from './AppOffersCallout.constants';
import * as St from './AppOffersCallout.styles';
import { AppOffersCalloutProps } from './AppOffersCallout.types';

export function AppOffersCallout({ offers }: AppOffersCalloutProps) {
  const { t } = useTranslation();
  const rows = buildOfferRows(t, offers);
  const { alliances } = offers;

  if (!rows.length) {
    return null;
  }

  const ctaUrl = alliances[0]?.appDownloadUrl ?? APP_DOWNLOAD_FROM_SMART_PRICING_URL;
  let trackingCampaign = 'smart_pricing';

  if (alliances.length === 1) {
    trackingCampaign = alliances[0].campaign;
  } else if (alliances.length > 1) {
    trackingCampaign = 'alliances';
  }

  const onClickDownload = () => {
    mixpanelTrackEvent('AppDownloadBannerClicked', {
      source: APP_OFFERS_CALLOUT_SOURCE,
      campaign: trackingCampaign,
    });
  };

  return (
    <St.Container data-testid="app-offers-callout">
      <St.Content>
        <SaleIcon />
        <St.Rows>
          <St.Title>{t('APP_OFFERS.TITLE')}</St.Title>
          {rows.map((row) => (
            <St.Row key={row.key}>
              <strong>{row.value}</strong> {row.detail}
            </St.Row>
          ))}
        </St.Rows>
      </St.Content>
      <St.DownloadLink href={ctaUrl} target="_blank" rel="noopener noreferrer" onClick={onClickDownload}>
        <span className="short">{t('APP_OFFERS.DOWNLOAD_SHORT')}</span>
        <span className="long">{t('APP_OFFERS.DOWNLOAD')}</span>
      </St.DownloadLink>
    </St.Container>
  );
}
